import { Inspector } from 'react-dev-inspector';
import { createRoot } from 'react-dom/client';

// 负责更改根font-size
import 'amfe-flexible';
import { ConfigProvider } from 'antd-mobile';
import 'antd-mobile/es/global';
import 'core-js/features/promise/all-settled';

// 国际化
import { getAntdLocale, setupI18n } from '@/locales';
// 与客户端通信
import '@/plugins/setupCommunication.js';
// 重置样式
import '@/styles/css/reset.css';

import App from './app.tsx';
import { setupQuery } from './plugins/setupQuery.ts';
import { applyResolvedPackageName } from './utils/packageIdentity';

async function setupApp() {
  setupQuery();

  try {
    applyResolvedPackageName();
  } catch (error) {
    console.error('applyResolvedPackageName failed:', error);
  }

  try {
    await setupI18n();
  } catch (error) {
    console.error('setupI18n failed, fallback to English UI bootstrap:', error);
  }

  createRoot(document.getElementById('root')!).render(
    <ConfigProvider locale={getAntdLocale(window.lang || 'en')}>
      <Inspector keys={['ctrl', 'alt', 'q']} />
      <App />
    </ConfigProvider>,
  );
}

setupApp();
